import { render, staticRenderFns } from "./ReceptionModal.vue?vue&type=template&id=64381a5c&scoped=true"
import script from "./ReceptionModal.vue?vue&type=script&lang=js"
export * from "./ReceptionModal.vue?vue&type=script&lang=js"
import style0 from "./ReceptionModal.vue?vue&type=style&index=0&id=64381a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64381a5c",
  null
  
)

export default component.exports